import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation, Trans} from "react-i18next";
import * as ApiHelper from "../../../api/ApiHelper";
import {useAbortController} from "../../../hooks";
import Loader from "../../Widgets/Loader/Loader";
import {Button} from "../../Widgets/Button/Button";
import {AccountSettings} from "../../Widgets/AccountSettings/AccountSettings";
import {ACCOUNT_ROUTE, SIGN_IN_ROUTE} from "../../../routes";
import {useEmailLinkLanguage} from "../useEmailLinkLanguage";

function ConfirmEmail() {
    const {t} = useTranslation();
    const history = useNavigate();
    const [controller] = useAbortController();
    const {searchParams} = useEmailLinkLanguage();
    const userId = searchParams.get("userId");
    const code = searchParams.get("code");
    const [isFetching, setFetchingState] = useState(true);
    const [email, setEmail] = useState<string | null>(null);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        if (!userId || !code) {
            setFailed(true);
            setFetchingState(false);
            return;
        }
        setFetchingState(true);
        ApiHelper.confirmEmail(
            userId,
            code,
            controller,
            (confirmedEmail) => {
                setEmail(confirmedEmail);
                setFailed(false);
                setFetchingState(false);
            },
            () => {
                setFailed(true);
                setFetchingState(false);
            }
        );
    }, [controller, userId, code]);

    const handleSignInClick = () => {
        history(ACCOUNT_ROUTE + SIGN_IN_ROUTE, {replace: true});
    };

    if (isFetching) {
        return <Loader/>;
    }

    return (
        <div className="window-modal-container">
            <div className="window-modal">
                <div className="window-modal-title disable-select pb-4 d-flex justify-content-center">
                    {t("email_confirmation_title")}
                </div>
                <div className="window-modal-text my-2">
                    {failed ? (
                        t("email_confirmation_failed")
                    ) : (
                        <Trans
                            i18nKey="email_confirmation_success"
                            values={{email: email ?? ""}}
                            components={{bold: <strong/>}}
                        />
                    )}
                </div>
                <div className="d-flex justify-content-center">
                    <div className="window-modal-button">
                        <Button className="mt-4" text={t("sign_in")} highlighted={true} onClick={handleSignInClick}/>
                    </div>
                </div>
                <div className="mt-4"/>
                <AccountSettings/>
            </div>
        </div>
    );
}

export default ConfirmEmail;
